<script setup lang="ts">
import { ref, computed } from 'Vue'
import ProductCard from './ProductCard.vue'
import ProductFilter from './ProductFilter.vue'
import { get, isEmpty } from 'lodash-es'

const props = defineProps<{
	choices: PartChoice[];
	filters: PartChoiceFilter[];
	closePicker: () => void;
	setChoiceAndClosePicker: () => void;
	heading: string;
}>();

// const jsonData = JSON.stringify( props.choices );
const choices = props.choices;
const closePicker = props.closePicker;
const setChoiceAndClosePicker = props.setChoiceAndClosePicker;
const activeChoices = ref<{[key:string]: string}>({})

const onFilterChange = function(name: string, value: string): void {
	console.log('filter change name:' + name + ' value:' + value)

	if (value) {
		activeChoices.value[name] = value;
	} else {
		delete activeChoices.value[name];
	}
}

const resetFilter = function(): void {
	activeChoices.value = {}
}

const matchesActiveFilters = (choice: PartChoice): Boolean => {
	return Object
		.keys(activeChoices.value)
		.every((name: string): Boolean => {
			const filterValue = activeChoices.value[name]
			const choiceData = choice.details.find((detail: PartChoiceData) => detail.title === name);
			return filterValue === choiceData?.value;
		})
}

const filteredChoices = computed(() => {
	return choices.filter((choice: PartChoice) => {
		return matchesActiveFilters(choice)
	})
})

const resetDisabled = computed(() => {
	return isEmpty(activeChoices.value)
});

</script>

<template>
<h2 class="product-heading">{{ props.heading }}</h2>

<button @click="closePicker()" type="button" class="button button--mb is-style-outline">
	<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2.73157 5.88863L6.36796 2.25224C6.55928 2.05978 6.66667 1.79943 6.66667 1.52805C6.66667 1.25667 6.55928 0.996316 6.36796 0.803852C6.27246 0.707572 6.15885 0.631152 6.03367 0.579001C5.9085 0.52685 5.77423 0.5 5.63863 0.5C5.50302 0.5 5.36876 0.52685 5.24358 0.579001C5.1184 0.631152 5.00479 0.707572 4.90929 0.803852L0.553852 5.15929C0.457572 5.25479 0.381152 5.3684 0.329001 5.49358C0.27685 5.61876 0.25 5.75302 0.25 5.88863C0.25 6.02423 0.27685 6.1585 0.329001 6.28367C0.381152 6.40885 0.457572 6.52246 0.553852 6.61796L4.90929 11.0248C5.00528 11.12 5.11911 11.1953 5.24427 11.2464C5.36942 11.2975 5.50344 11.3234 5.63863 11.3227C5.77382 11.3234 5.90783 11.2975 6.03298 11.2464C6.15814 11.1953 6.27197 11.12 6.36796 11.0248C6.55928 10.8323 6.66667 10.5719 6.66667 10.3006C6.66667 10.0292 6.55928 9.76883 6.36796 9.57637L2.73157 5.88863Z" fill="#55806B"/>
	</svg>Tilbake til tilpass garasje
</button>

<div class="product-filters-grid">
	<ProductFilter v-for="filter in filters" :filter="filter" :onFilterChange="onFilterChange" :value="get(activeChoices, filter.label, '')" />
	<div class="product-filters-reset">
		<button @click="resetFilter()" type="button" class="button is-style-outline" :disabled="resetDisabled">
			Nullstill filtrering
		</button>
	</div>
</div>

<div class="product-cards-message" v-if="!filteredChoices.length">
	Ingen treff samsvarer med disse valgene.
</div>

<div class="product-cards-grid" v-if="!!filteredChoices.length">
	<ProductCard
		v-for="choice in filteredChoices"
		:key="choice.prodNo"
		:choice="choice"
		:setChoiceAndClosePicker="setChoiceAndClosePicker"
		:closePicker="closePicker"
	/>
</div>

<button @click="closePicker()" type="button" class="button button--mb is-style-outline">
	<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M2.73157 5.88863L6.36796 2.25224C6.55928 2.05978 6.66667 1.79943 6.66667 1.52805C6.66667 1.25667 6.55928 0.996316 6.36796 0.803852C6.27246 0.707572 6.15885 0.631152 6.03367 0.579001C5.9085 0.52685 5.77423 0.5 5.63863 0.5C5.50302 0.5 5.36876 0.52685 5.24358 0.579001C5.1184 0.631152 5.00479 0.707572 4.90929 0.803852L0.553852 5.15929C0.457572 5.25479 0.381152 5.3684 0.329001 5.49358C0.27685 5.61876 0.25 5.75302 0.25 5.88863C0.25 6.02423 0.27685 6.1585 0.329001 6.28367C0.381152 6.40885 0.457572 6.52246 0.553852 6.61796L4.90929 11.0248C5.00528 11.12 5.11911 11.1953 5.24427 11.2464C5.36942 11.2975 5.50344 11.3234 5.63863 11.3227C5.77382 11.3234 5.90783 11.2975 6.03298 11.2464C6.15814 11.1953 6.27197 11.12 6.36796 11.0248C6.55928 10.8323 6.66667 10.5719 6.66667 10.3006C6.66667 10.0292 6.55928 9.76883 6.36796 9.57637L2.73157 5.88863Z" fill="#55806B"/>
	</svg>Tilbake til tilpass garasje
</button>

<!----<div>{{jsonData}}</div>-->
</template>

<style lang="scss" scoped>
.product-cards-message {
	margin-bottom: 53px;
}
.product-filters-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill,minmax(250px,1fr));
	grid-gap: 20px;
	margin-bottom: 53px;
}
.product-filters-reset {
	display: flex;
	align-items: end;
}
.product-cards-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	grid-column-gap: 20px;
    grid-row-gap: 40px;
	margin-bottom: 53px;
}

.button {
	pointer-events: all;
	visibility: visible;

	&--mb {
		margin-bottom: 20px;
	}

	&:disabled {
		pointer-events: none;
		visibility: hidden;
	}

	svg {
		display: inline-block;
		margin-right: 0.5rem;
		fill: currentColor;

		path {
			fill: currentColor;
		}
	}
}
</style>
